<template>
    <BaseCard :data="data" :hideBorder="true">
        <div slot="actions">
            <div class="action-item">
                <Button
                    variant="outline-primary"
                    outline
                    @click="
                        goToBook();
                        logAppointmentTypeClickEvent();
                    "
                >
                    Book now
                </Button>
            </div>
        </div>
        <div slot="details" class="details-container">
            <div class="details-item">
                <font-awesome-icon class="gray-color" icon="clock" />
                {{ data.duration }} {{ $t('general.minutesShort') }}
            </div>
            <div
                v-if="data.location"
                v-b-tooltip.hover
                class="details-item nowrap"
                :title="data.location"
            >
                <font-awesome-icon class="gray-color" icon="map-marker-alt" />
                {{ data.location }}
            </div>
        </div>
    </BaseCard>
</template>

<script>
import AnalyticService from '~/services/AnalyticService';
import Button from '~/components/builders/Base/Button';
import Icon from '~/components/builders/Base/Icon';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BaseCard from './BaseCard';

export default {
    name: 'BookAppointmentCard',
    components: {
        Button,
        FontAwesomeIcon,
        BaseCard,
    },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    data: () => ({
        hasLoggedAppointmentClickEvent: false,
    }),
    methods: {
        goToBook() {
            this.$router.push(
                this.$URLS.calendar
                    .concat(this.$URLS.book)
                    .concat('/')
                    .concat(this.data.id)
            );
        },
        async logAppointmentTypeClickEvent() {
            if (this.hasLoggedAppointmentClickEvent || !this.data.id) return;
            AnalyticService.appointmentTypeClickEvent(this.data.id);
            this.hasLoggedAppointmentClickEvent = true;
        },
    },
};
</script>

<style scoped>
.calendar-available-item-wrapper {
    padding: 20px;
}

.calendar-available-item-content {
    margin-left: 20px;
}

.calendar-available-item-span {
    font-size: 12px;
    padding-top: 5px;
    color: #141414;
}

.calendar-event-title {
    font-weight: bold !important;
    color: rgba(0, 0, 0, 0.7);
}

.first-available {
    color: var(--primary);
}
.divider {
    margin: 0;
    width: 100%;
    border-top: 1px solid #f3f3f3;
}

.details-container {
    display: flex;
    flex-direction: row;
}

.details-item {
    padding-right: 1em;
    padding-bottom: 1em;

    max-width: 200px;
}

.action-container {
    display: grid;
    grid-template-rows: 1fr 1fr;
}
.action-item {
    padding-right: 1em;
    align-items: center;
}

/* TODO: won't work from inside the button... */
.outline-primary {
    border-color: var(--primary);
    color: var(--primary);
}
.outline-primary:hover:not(.disabled) {
    background-color: var(--primary);
    color: white;
}
.outline-primary:active {
    border-color: var(--primary);
    outline-width: 2px;
    outline-color: var(--primary);
}
</style>
